import React from 'react'
import {Link} from 'react-router-component'
import CSSTransition from 'react-addons-css-transition-group'
import BatchOptions from './batch-options'
import EditAll from './batch-edit-all'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import EditorActions from '../../../actions/editor-actions'
import createReactClass from 'create-react-class'


var Batch = createReactClass({
	getInitialState: function() {
		return { quantityValue: 1 };
	},

	toggleBatchOptions: function() {
		// Call callback from parent
		this.props.toggleCallback();
	},

	quantityValueUpdated: function(newQuantity) {
		this.setState({quantityValue: newQuantity });

		// Create action that updates the quantity of any products in the Order
		EditorActions.setBatchQuantity(newQuantity);
	},

	render: function() {
		return (
			<div>
			<header className="ope-section__header">
			 	<div className="row">
					<h2 className="small-8 large-7 columns">{_("Edit your photos")}</h2>
					<div className=" small-4 large-5 columns">
						<EditAll callback={this.toggleBatchOptions} expanded={this.props.expanded} />
					</div>
			 	</div>
			</header>
			{ this.props.expanded ?
			 		<BatchOptions doneCallback={this.toggleBatchOptions} quantityValue={this.state.quantityValue}
			 			quantityCallback={this.quantityValueUpdated} key="batchOptions" batchAllCallback={this.props.batchAllCallback} />
			 	: null }
			</div>
		);
	}
});

export default Batch;
